/**
 * Html valide pour un bouton de la toolbar
 * @param {Element|string} [html] contenu du bouton (priorité 1)
 * @param {string} [iconId] id du d'element du DOM (priorité 2)
 * @param {string} [icon] <i class='icon'/> du bouton (priorité 3)
 * @param {string} [defaultHtml=''] texte par défaut (priorité 4)
 * @returns {Element|string} contenu du bouton
 */
export function getButtonHtml (html, iconId, icon, defaultHtml = null) {
  return html || (iconId && document.getElementById(iconId) !== null
    ? document.getElementById(iconId).cloneNode(true)
    : icon
      ? `<i class="${icon}"></i>`
      : defaultHtml)
}

export default {
  getButtonHtml,
}
